import React from 'react';
import './WidgetNote.css';

const WidgetNote = ({ children }) => (
  <div className="WidgetNote">{children}</div>
);
export default WidgetNote;
